module.exports = __webpack_public_path__ + "img/人才招聘小程序V1.0.c376e2e5.jpg";